import Marquee from "react-fast-marquee";

const BRANDS = [
  "SOLARA", "VEGA", "MAX HEALTHCARE", "MERIDIAN",
  "VOLTCRAFT", "ATLAS", "NORTHSTAR", "LRC",
  "PEEKABOO KIDZ", "SENCO", "TANISHQ", "KALYAN",
  "ELECTRO WORLD", "SQUARE YARDS", "HONEY GOLF GREENS",
  "INDANE (IOC)",
];

export default function ClientMarquee() {
  return (
    <div className="marquee-fade">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {BRANDS.concat(BRANDS).map((b, i) => (
          <div
            key={i}
            className="mx-10 md:mx-14 font-display text-xl md:text-2xl font-black tracking-[0.18em] text-zinc-500 hover:text-white transition-colors duration-500 whitespace-nowrap"
            data-testid={`client-logo-${i}`}
          >
            {b}
          </div>
        ))}
      </Marquee>
    </div>
  );
}
